import NoDataView from './NoDataView';

export default NoDataView;
